import React from 'react';
import s from './Team.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';

import Button from 'react-bootstrap/Button';

const TeamListTable = ({ paginatedData, ChangeTeam, RemoveTeam, UpdateAllowed, DeleteAllowed, intl }) => {
  return (
    <div className="">
      <Table variant className={s.table}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="common.name" defaultMessage="Name" />{' '}
            </th>
            <th>
              <FormattedMessage id="team.role" defaultMessage="Role" />
            </th>
            <th>
              <FormattedMessage id="personnel.company" defaultMessage="Company" />
            </th>
            <th>
              <FormattedMessage id="personnel.jobTitle" defaultMessage="Job Title" />
            </th>
            <th>
              <FormattedMessage id="common.phone" defaultMessage="Phone" />
            </th>

            {(UpdateAllowed || DeleteAllowed) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <tr key={n.TeamId}>
                <td>{n.Name || ''}</td>
                <td>{n.Role || ''}</td>
                <td>{n.Company || ''}</td>
                <td>{n.JobTitle || ''}</td>
                <td>{n.Phone || ''}</td>
                <td className={s.btnCol}>
                  {DeleteAllowed && (
                    <Button
                      variant="outline-secondary"
                      className={s.opButton}
                      href="#"
                      onClick={() => {
                        RemoveTeam(n.TeamId);
                      }}
                      data-unittest="removeData"
                    >
                      <FormattedMessage id="common.remove" defaultMessage="REMOVE" />
                    </Button>
                  )}
                  {UpdateAllowed && (
                    <Button
                      variant="outline-secondary"
                      className={s.opButton}
                      href="#"
                      onClick={() => {
                        ChangeTeam(n.TeamId);
                      }}
                      data-unittest="changeData"
                    >
                      <FormattedMessage id="common.change" defaultMessage="CHANGE" />
                    </Button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

TeamListTable.defaultProps = {
  paginatedData: [],
  currentPage: 1
};

export default injectIntl(TeamListTable);
